import { ShieldCheck } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui/tooltip'

export function ManagesUsersBadge() {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span className="text-muted-foreground flex shrink-0 items-center">
            <ShieldCheck className="size-3.5" aria-label="Manages users" />
          </span>
        }
      />
      <TooltipContent side="right" sideOffset={8}>
        Manages users
      </TooltipContent>
    </Tooltip>
  )
}
